import Axios from "axios";
import header from "./auth/header";

const API_URL = process.env.API_URL + '/api/v1/';
const API_URL_V3 = process.env.API_URL + '/api/v3/';

class UserBank {
    index() {
        return Axios.get(API_URL + 'userbank-list', { headers: header() })
    }

    // me() {
    //     return Axios.get(API_URL + 'userbank-me', { headers: header() })
    // }

    me() {
        return Axios.get(API_URL_V3 + 'user-banks/me', { headers: header() })
    }

    show(id) {
        return Axios.get(API_URL + `show-userbank/${id}`, { headers: header() });
    }

    showV3(id) {
        return Axios.get(API_URL_V3 + `user-banks/${id}`, { headers: header() });
    }

    store(data) {
        return Axios.post(API_URL + 'add-userbank', data, { headers: header() });
    }

    // update(data) {
    //     return Axios.patch(API_URL + 'update-userbank', data, { headers: header() })
    // }

    update(data) {
        return Axios.post(API_URL_V3 + 'user-banks/upsert', data, { headers: header() })
    }

    destroy(data) {
        return Axios.delete(API_URL + 'delete-userbank', data, { headers: header() })
    }
}

export default new UserBank();



// WEBPACK FOOTER //
// ./src/api/userbank.js